import { createStore, withProps } from '@ngneat/elf';
import {DynaStatus} from '@/types';

export interface DynaDocsModelStateProps {
  response: any;
  dto: { description: string,status:DynaStatus };
  isEqual: boolean;
  serverState: any;
}

export const dynaDocsModelInitialState: DynaDocsModelStateProps = {
  response: [],
  dto: { description: '',status:DynaStatus.ACTIF },
  isEqual: true,
  serverState: undefined,
};

export const dynaDocsModelStateStore = createStore(
  { name: 'dyna-docs-model-state' },
  withProps<DynaDocsModelStateProps>({
    ...dynaDocsModelInitialState,
  })
);
